import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import useResponsive from '../../hooks/useResponsive'

const UnauthorizedPage = () => {
  const isMobile = useResponsive('md');
  const pageStyle = {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column' as const
  };
  
  const mainStyle = {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const contentStyle = {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    textAlign: 'center' as const
  };

  const errorCodeStyle = {
    fontSize: isMobile ? '6rem' : '10rem',
    fontWeight: 'bold',
    marginBottom: isMobile ? '0rem' : '1rem',
    backgroundImage: 'linear-gradient(90deg, #0057b8, #00a8e0)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    color: 'transparent',
    display: 'block'
  };

  const titleStyle = {
    fontSize: isMobile ? '2rem' : '3rem',
    marginBottom: '1rem',
    color: '#0057b8'
  };

  const messageStyle = {
    fontSize: isMobile ? '1rem' : '1.5rem',
    color: '#555'
  };

  return (
    <div style={pageStyle}>
      
      <main style={mainStyle}>
        <div style={contentStyle}>
          <div style={errorCodeStyle}>401</div>
          <h1 style={titleStyle}>Unauthorized</h1>
          <p style={messageStyle}>Authorization required.</p>
        </div>
      </main>
      
    </div>
  )
}

export default UnauthorizedPage